import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { LinkClickTrackingService } from './link-click-tracking.service';

interface PendingLink {
  url: string;
  conversationId: string;
}

@Injectable({ providedIn: 'root' })
export class LinkConfirmationService {
  readonly pendingLink$ = new BehaviorSubject<PendingLink | null>(null);

  constructor(private linkClickTrackingService: LinkClickTrackingService) {}

  openLink(url: string, conversationId: string): void {
    this.pendingLink$.next({ url, conversationId });
  }

  confirm(): void {
    const pending = this.pendingLink$.value;
    if (pending) {
      this.linkClickTrackingService.trackLinkClick(pending.conversationId, pending.url);
      window.open(pending.url, '_blank', 'noopener,noreferrer');
    }
    this.pendingLink$.next(null);
  }

  cancel(): void {
    this.pendingLink$.next(null);
  }
}
